import { type SelectProps } from '@/components/selects/Select'
import { TagRender } from '@/components/selects/TagRender'
import styles from './styles.module.scss'

export interface useMultipleSelectCountProps {
  countLabel?: string
  value?: string | string[]
}

export function useMultipleSelectCount({
  countLabel,
  value,
}: useMultipleSelectCountProps): Partial<SelectProps> {
  if (!countLabel || !Array.isArray(value)) return {}

  function tagRender() {
    const count = value?.length ?? 0
    return <TagRender label={countLabel ?? ''} count={count} />
  }

  return { tagRender, maxTagCount: 1, mode: 'multiple', className: styles.hideTagsRest }
}
